(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hmg-impact-counter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hmg-impact-counter')) {
    class HmgImpactCounter extends HTMLElement {
      static requests = new Map();
      connectedCallback() {
        if (this.dataset.state) return;
        this.dataset.state = 'waiting';
        this.start = () => {
          if (!this.isConnected || this.dataset.state !== 'waiting') return;
          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(entries => {
              if (entries.some(entry => entry.isIntersecting)) {
                this.observer.disconnect();
                this.load();
              }
            }, {rootMargin: '120px 0px'});
            this.observer.observe(this);
          } else {
            this.dataset.state = 'unavailable';
            this.querySelector('[data-impact-status]').textContent = this.dataset.failure;
          }
        };
        if (document.readyState === 'complete') this.start();
        else window.addEventListener('load', this.start, {once: true});
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        window.removeEventListener('load', this.start);
        if (this.dataset.state === 'waiting') delete this.dataset.state;
      }
      static async totals(shop) {
        if (!/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/i.test(shop)) throw new Error('Invalid shop');
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 8000);
        try {
          const uri = new URL('https://sprout-app.thegoodapi.com/app/badges/tree_count');
          uri.search = new URLSearchParams({shop, locale: 'en', hide_tree_count: 'false', hide_plastics_count: 'false'});
          const response = await fetch(uri, {credentials: 'omit', signal: controller.signal});
          if (!response.ok) throw new Error('Impact unavailable');
          const markup = await response.text();
          if (markup.length > 100000) throw new Error('Unexpected response');
          const doc = new DOMParser().parseFromString(markup, 'text/html');
          const counts = {};
          doc.querySelectorAll('.spt-impact-banner-details').forEach(item => {
            const label = item.querySelector('.spt-impact-banner-subtext')?.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
            const value = item.querySelector('.spt-impact-banner-total')?.textContent.trim();
            if (!value || !/^(?:\d+|\d{1,3}(?:,\d{3})+)$/.test(value)) return;
            const number = Number(value.replace(/,/g, ''));
            if (!Number.isSafeInteger(number)) return;
            if (label === 'trees planted') counts.trees = number;
            if (label === 'plastic bottles removed') counts.bottles = number;
          });
          if (counts.trees === undefined || counts.bottles === undefined) throw new Error('Missing impact totals');
          return counts;
        } finally {
          clearTimeout(timer);
        }
      }
      async load() {
        if (this.dataset.state !== 'waiting') return;
        this.dataset.state = 'loading';
        const image = this.querySelector('template[data-impact-image]');
        if (image) { this.prepend(image.content.cloneNode(true)); image.remove(); }
        try {
          const shop = this.dataset.shop;
          if (!HmgImpactCounter.requests.has(shop)) HmgImpactCounter.requests.set(shop, HmgImpactCounter.totals(shop));
          const counts = await HmgImpactCounter.requests.get(shop);
          if (!this.isConnected) { delete this.dataset.state; return; }
          const format = new Intl.NumberFormat(this.dataset.locale || 'en-AU');
          this.querySelector('[data-impact-trees]').textContent = format.format(counts.trees);
          this.querySelector('[data-impact-bottles]').textContent = format.format(counts.bottles);
          this.querySelector('[data-impact-status]').textContent = 'GoodAPI';
          this.dataset.state = 'ready';
        } catch (_) {
          this.dataset.state = 'unavailable';
          this.querySelector('[data-impact-status]').textContent = this.dataset.failure;
        }
      }
    }
    customElements.define('hmg-impact-counter', HmgImpactCounter);
  }

  } catch(e) { console.error(e); }
})();
})();
